import RatingPoint from '@/atoms/RatingPoint'

function Rating({ rating = 0, votes }: RatingProps): JSX.Element {
  // const { t } = useTranslation('shopping')
  const score = +(Math.ceil((rating as number) * 2) / 2).toFixed(2)

  return (
    <div>
      <div className="flex items-end">
        <div className="flex items-center space-x-1" aria-label={`${score}/5`}>
          {[...Array(5)].map((_, index) => {
            return <RatingPoint key={index} value={index + 1} rating={rating} />
          })}
        </div>

        {votes ? (
          <span className="ml-2 text-xs leading-none text-gray-100 md:text-sm">
            ({votes})
          </span>
        ) : null}
      </div>
    </div>
  )
}

interface RatingProps {
  rating: number
  votes?: number
}

export default Rating
